var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartnerBundleDisplay',{attrs:{"plan":_vm.bundlePlan,"pageAttributes":_vm.pageAttributes,"backgroundImageSet":_vm.backgroundImageSet,"heading":_vm.heading,"description":_vm.description},on:{"selectPlan":_vm.onSelectPlan,"continue":_vm.onContinue}})
}
var staticRenderFns = []

export { render, staticRenderFns }